<template>
  <div>
    <v-dialog v-model="uploadLogoDialog" width="500" lazy>
      <v-toolbar dark card dense height="36" color="theme_primary" class="bordered white--text">
        <v-icon small pa-0 color="white">mdi-cloud-upload</v-icon>
        <v-toolbar-title style="margin-left: 8px;">
          <h6>Upload company logo</h6>
        </v-toolbar-title>
      </v-toolbar>
      <v-card>
        <v-card-text>
          <!-- <v-container grid-list-md text-xs-center> -->
          <uploader
            name="Company logo"
            v-on:s3url="updateCompanyLogo($event)"
            displayName="Drop the company logo here, or click to browse"
            :fileName="companyLogoName"
          />
          <!-- </v-container> -->
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn @click="uploadLogoDialog = false" style="float: right;" color="primary" flat>Close</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- NEW -->
    <v-card class="elevation-1 my-4">
      <!-- IDENTITY -->
      <v-card flat class="elevation-0 my-0">
        <v-card-title class="py-0">
          <span class="primary--text">Identity</span>
          <v-spacer></v-spacer>
          <v-btn flat dark small v-show="editMode" depressed color="error" @click="cancel()">
            <v-icon small class="pr-2">mdi-undo</v-icon>Cancel
          </v-btn>
          <v-btn
            :flat="!editMode"
            dark
            small
            :color="editMode ? 'ctcGreen' : 'primary'"
            depressed
            @click="editMode ? save() : (editMode = true)"
          >
            <v-icon small class="pr-2">{{ editMode ? "save" : "edit" }}</v-icon>
            {{ editMode ? "Save" : "Edit" }}
          </v-btn>
        </v-card-title>

        <!-- Name -->
        <v-layout my-2 align-center>
          <v-flex xs5 offset-xs1>
            <span style="color: #757575;">
              <v-icon small class="pr-1" color="#757575">mdi-card-bulleted</v-icon>Name:
            </span>
          </v-flex>
          <v-flex xs6 v-if="!editMode">{{ tempCompany.name }}</v-flex>
          <v-flex xs5 v-if="editMode">
            <v-text-field
              flat
              hide-details
              solo
              single-line
              label="Name"
              class="dense-input"
              background-color="#f4f4f4"
              v-model="tempCompany.name"
            />
          </v-flex>
        </v-layout>
        <v-flex class="px-5">
          <v-divider />
        </v-flex>
        <!-- Short Name-->
        <v-layout my-2 align-center>
          <v-flex xs5 offset-xs1>
            <span style="color: #757575;">
              <v-icon small class="pr-1" color="#757575">mdi-format-quote-close</v-icon>Short Name:
            </span>
          </v-flex>
          <v-flex xs6 v-if="!editMode">{{ tempCompany.short_name }}</v-flex>
          <v-flex xs5 v-if="editMode">
            <v-text-field
              flat
              hide-details
              solo
              single-line
              label="Short Name"
              class="dense-input"
              background-color="#f4f4f4"
              v-model="tempCompany.short_name"
            />
          </v-flex>
        </v-layout>

        <!-- <v-flex class="px-5">
          <v-divider />
        </v-flex>-->

        <!-- Company TYPE -->
        <!-- <v-layout my-2 align-center>
          <v-flex xs5 offset-xs1>
            <span style="color: #757575">
              <v-icon small class="pr-1" color="#757575">local_offer</v-icon>Type:
            </span>
          </v-flex>
          <v-flex xs6 v-if="!editMode">
            <v-radio-group
              disabled
              height="24"
              hide-details
              row
              class="mt-0 pt-0"
              :value="companyTypeIndex"
            >
              <v-radio height="24" color="amber darken1" label="Supplier" :value="0"></v-radio>
              <v-radio height="24" color="blue" label="Customer" :value="1"></v-radio>
              <v-radio height="24" color="purple" label="Subsidiary" :value="2"></v-radio>
            </v-radio-group>
          </v-flex>
          <v-flex xs5 v-if="editMode">
            <v-radio-group
              height="24"
              hide-details
              row
              class="mt-0 pt-0"
              v-model="companyTypeIndex"
            >
              <v-radio height="24" color="amber darken1" label="Supplier" :value="0"></v-radio>
              <v-radio height="24" color="blue" label="Customer" :value="1"></v-radio>
              <v-radio height="24" color="purple" label="Subsidiary" :value="2"></v-radio>
            </v-radio-group>
          </v-flex>
        </v-layout>-->
      </v-card>

      <!-- ADDRESS -->
      <v-card flat class="elevation-0 my-0 pt-2">
        <v-card-title class="py-0">
          <span class="primary--text">Address</span>
        </v-card-title>

        <!-- Address 1 -->
        <v-layout my-2 align-center>
          <v-flex xs5 offset-xs1>
            <span style="color: #757575;">
              <v-icon small class="pr-1" color="#757575">mdi-map-marker</v-icon>Address 1:
            </span>
          </v-flex>
          <v-flex xs6 v-if="!editMode">{{ tempCompany.address1 }}</v-flex>
          <v-flex xs5 v-if="editMode">
            <v-text-field
              flat
              hide-details
              solo
              single-line
              label="Address 1"
              class="dense-input"
              background-color="#f4f4f4"
              v-model="tempCompany.address1"
            />
          </v-flex>
        </v-layout>
        <v-flex class="px-5">
          <v-divider />
        </v-flex>
        <!-- Address 2 -->
        <v-layout my-2 align-center>
          <v-flex xs5 offset-xs1>
            <span style="color: #757575;">
              <v-icon small class="pr-1" color="#757575">mdi-map-marker</v-icon>Address 2:
            </span>
          </v-flex>
          <v-flex xs6 v-if="!editMode">{{ tempCompany.address2 }}</v-flex>
          <v-flex xs5 v-if="editMode">
            <v-text-field
              flat
              hide-details
              solo
              single-line
              label="Address 2"
              class="dense-input"
              background-color="#f4f4f4"
              v-model="tempCompany.address2"
            />
          </v-flex>
        </v-layout>
        <v-flex class="px-5">
          <v-divider />
        </v-flex>
        <!-- Country -->
        <v-layout my-2 align-center>
          <v-flex xs5 offset-xs1>
            <span style="color: #757575;">
              <v-icon small class="pr-1" color="#757575">mdi-flag</v-icon>Country:
            </span>
          </v-flex>
          <v-flex xs6 v-if="!editMode">
            <flag
              class="pr-4"
              v-if="tempCompany.country_id"
              :iso="
                countries.find((c) => c.id == tempCompany.country_id).iso_code
              "
            />
            {{ getNameById(tempCompany.country_id, "countries") }}
          </v-flex>
          <v-flex xs5 v-if="editMode">
            <v-autocomplete
              :items="countries"
              item-value="id"
              item-text="name"
              v-model="tempCompany.country_id"
              hide-details
              solo
              flat
              dense
              label="Country"
              single-line
              class="dense-input"
              background-color="#f4f4f4"
              browser-autocomplete="noautocomplete"
            />
          </v-flex>
        </v-layout>
        <v-flex class="px-5">
          <v-divider />
        </v-flex>

        <!-- City -->
        <v-layout my-2 align-center>
          <v-flex xs5 offset-xs1>
            <span style="color: #757575;">
              <v-icon small class="pr-1" color="#757575">mdi-city</v-icon>City:
            </span>
          </v-flex>
          <v-flex xs6 v-if="!editMode">
            {{
            getNameById(tempCompany.city_id, "cities")
            }}
          </v-flex>
          <v-flex xs5 v-if="editMode">
            <v-autocomplete
              :items="citiesFromCountry(tempCompany.country_id)"
              item-value="id"
              item-text="name"
              v-model="tempCompany.city_id"
              hide-details
              solo
              flat
              dense
              label="City"
              single-line
              :disabled="!tempCompany.country_id"
              class="dense-input"
              background-color="#f4f4f4"
              browser-autocomplete="noautocomplete"
            />
          </v-flex>
        </v-layout>
      </v-card>

      <!-- FISCAL -->
      <v-card flat class="elevation-0 my-0 pt-2">
        <v-card-title class="py-0">
          <span class="primary--text">Fiscal</span>
        </v-card-title>

        <!-- Fiscal Number -->
        <v-layout my-2 align-center>
          <v-flex xs5 offset-xs1>
            <span style="color: #757575;">
              <v-icon small class="pr-1" color="#757575">mdi-barcode</v-icon>Fiscal Number:
            </span>
          </v-flex>
          <v-flex xs6 v-if="!editMode">{{ tempCompany.fiscal_number }}</v-flex>
          <v-flex xs5 v-if="editMode">
            <v-text-field
              flat
              hide-details
              solo
              single-line
              label="Fiscal Number"
              class="dense-input"
              background-color="#f4f4f4"
              v-model="tempCompany.fiscal_number"
            />
          </v-flex>
        </v-layout>
        <v-flex class="px-5">
          <v-divider />
        </v-flex>
        <!-- VAT-->
        <v-layout my-2 align-center>
          <v-flex xs5 offset-xs1>
            <span style="color: #757575;">
              <v-icon
                small
                style="position: relative; top: -3px; font-size: 14px;"
                class="pr-1"
                color="#757575"
              >%</v-icon>VAT:
            </span>
          </v-flex>
          <v-flex xs6 v-if="!editMode">{{ tempCompany.vat }}</v-flex>
          <v-flex xs5 v-if="editMode">
            <v-text-field
              flat
              hide-details
              solo
              single-line
              label="VAT"
              class="dense-input"
              background-color="#f4f4f4"
              v-model="tempCompany.vat"
            />
          </v-flex>
        </v-layout>
      </v-card>

      <!-- APP SETTINGS -->
      <v-card flat class="elevation-0 my-0 pt-2">
        <v-card-title class="py-0">
          <span class="primary--text">Application Settings</span>
        </v-card-title>

        <!-- Languages -->
        <v-layout my-2 align-center>
          <v-flex xs5 offset-xs1>
            <span style="color: #757575;">
              <v-icon small class="pr-1" color="#757575">mdi-earth</v-icon>Languages:
            </span>
          </v-flex>
          <v-flex xs6 v-if="!editMode">
            <v-label v-for="language in tempCompany.language_ids" :key="language">
              <v-chip text-color="#444">
                {{
                getNameById(language, "languages")
                }}
              </v-chip>
            </v-label>
          </v-flex>
          <v-flex xs5 v-if="editMode">
            <v-autocomplete
              :items="languages"
              item-value="id"
              item-text="name"
              v-model="tempCompany.language_ids"
              hide-details
              solo
              flat
              dense
              multiple
              label="Languages"
              single-line
              class="dense-input"
              background-color="#f4f4f4"
              browser-autocomplete="noautocomplete"
            />
          </v-flex>
        </v-layout>
        <v-flex class="px-5">
          <v-divider />
        </v-flex>
        <!-- Status -->
        <v-layout my-2 align-center>
          <v-flex xs5 offset-xs1>
            <span style="color: #757575;">
              <v-icon small class="pr-1" color="#757575">mdi-marker-check</v-icon>Status:
            </span>
          </v-flex>
          <v-flex xs6 v-if="!editMode">
            <v-label>
              <v-chip text-color="#444">
                {{
                getNameById(tempCompany.company_status_id, "company_statuses")
                }}
              </v-chip>
            </v-label>
          </v-flex>
          <v-flex xs5 v-if="editMode">
            <v-autocomplete
              :items="companyStatuses"
              item-value="id"
              item-text="name"
              v-model="tempCompany.company_status_id"
              hide-details
              solo
              flat
              dense
              label="Status"
              single-line
              class="dense-input"
              background-color="#f4f4f4"
              browser-autocomplete="noautocomplete"
            />
          </v-flex>
        </v-layout>
        <v-flex class="px-5">
          <v-divider />
        </v-flex>
        <!-- Ranking-->
        <v-layout my-2 align-center>
          <v-flex xs5 offset-xs1>
            <span style="color: #757575;">
              <v-icon small class="pr-1" color="#757575">mdi-star</v-icon>Ranking:
            </span>
          </v-flex>
          <v-flex xs6 v-if="!editMode">{{ tempCompany.ranking }}</v-flex>
          <v-flex xs5 v-if="editMode">
            <v-text-field
              flat
              hide-details
              solo
              single-line
              label="Ranking"
              class="dense-input"
              background-color="#f4f4f4"
              v-model="tempCompany.ranking"
            />
          </v-flex>
        </v-layout>
      </v-card>

      <!-- MISC -->
      <v-card flat class="elevation-0 my-0 pt-2">
        <v-card-title class="py-0">
          <span class="primary--text">Misc</span>
        </v-card-title>

        <!-- Website -->
        <v-layout my-2 align-center>
          <v-flex xs5 offset-xs1>
            <span style="color: #757575;">
              <v-icon small class="pr-1" color="#757575">mdi-link-variant</v-icon>Website:
            </span>
          </v-flex>
          <v-flex xs6 v-if="!editMode">
            <span v-show="!tempCompany.website">{{ tempCompany.website }}</span>
            <a
              href="tempCompany.website"
              target="_blank"
              v-show="tempCompany.website"
            >{{ tempCompany.website }}</a>
          </v-flex>
          <v-flex xs5 v-if="editMode">
            <v-text-field
              flat
              hide-details
              solo
              single-line
              label="Website"
              class="dense-input"
              background-color="#f4f4f4"
              v-model="tempCompany.website"
            ></v-text-field>
          </v-flex>
        </v-layout>
        <v-flex class="px-5">
          <v-divider />
        </v-flex>
        <!-- Logo URL-->
        <v-layout my-2 align-center>
          <v-flex xs5 offset-xs1>
            <span style="color: #757575;">
              <v-icon small class="pr-1" color="#757575">mdi-image</v-icon>Logo:
            </span>
          </v-flex>
          <v-flex xs6 v-if="!editMode">
            <v-avatar v-if="tempCompany.logo_url" size="18" class="mr-2">
              <img :src="s3bucket + '/' + tempCompany.logo_url" />
            </v-avatar>
            {{ tempCompany.logo_url }}
          </v-flex>
          <v-flex xs5 v-if="editMode">
            <v-text-field
              flat
              hide-details
              solo
              disabled
              single-line
              label="Logo url"
              class="dense-input"
              background-color="#f4f4f4"
              v-model="tempCompany.logo_url"
            >
              <template slot="append">
                <v-btn
                  flat
                  small
                  color="primary"
                  icon
                  @click="uploadLogoDialog = true"
                  style="pointer-events: auto;"
                >
                  <v-icon small>mdi-cloud-upload</v-icon>
                </v-btn>
              </template>
            </v-text-field>
          </v-flex>
        </v-layout>
      </v-card>

      <!-- USERS -->
      <v-card flat class="elevation-0 my-0 pb-4 pt-2">
        <v-card-title class="py-0">
          <span class="primary--text">Users</span>
        </v-card-title>

        <!-- Users -->
        <v-layout my-2 align-center>
          <v-flex xs5 offset-xs1>
            <span style="color: #757575;">
              <v-icon small class="pr-1" color="#757575">mdi-account-multiple-check</v-icon>Accounts:
            </span>
          </v-flex>

          <v-flex xs6 v-if="!editMode">
            <v-label v-for="uid in tempCompany.user_ids" :key="uid">
              <v-chip text-color="#444">
                <userAvatar
                  class="pl-2"
                  :size="14"
                  :last_name="getObjectById(uid, 'users').last_name"
                  :first_name="getObjectById(uid, 'users').first_name"
                  :url="getObjectById(uid, 'users').avatar_url"
                />
                {{ getNameById(uid, "users") }}
              </v-chip>
            </v-label>
          </v-flex>
          <v-flex xs5 v-if="editMode">
            <v-select
              :items="users"
              item-value="id"
              item-text="full_name"
              v-model="tempCompany.user_ids"
              hide-details
              solo
              flat
              dense
              multiple
              label="Accounts"
              single-line
              class="dense-input"
              background-color="#f4f4f4"
              browser-autocomplete="noautocomplete"
            >
              <!-- <v-tooltip slot="append" bottom>
                <v-icon slot="activator" class="help_icon" dark>help</v-icon>
                <span>Users with access to this company profile.</span>
              </v-tooltip>-->
              <template v-slot:selection="{ item, index }">
                <v-chip v-if="index < 2">
                  <span>{{ item.full_name }}</span>
                </v-chip>
                <span
                  v-if="index === 2"
                  class="grey--text caption"
                >(+{{ tempCompany.user_ids.length - 2 }} others)</span>
              </template>
            </v-select>
          </v-flex>
        </v-layout>
        <v-flex class="px-5">
          <v-divider />
        </v-flex>
        <!-- SalesForce Owner-->
        <v-layout my-2 align-center>
          <v-flex xs5 offset-xs1>
            <span style="color: #757575;">
              <v-icon small class="pr-1" color="#757575">mdi-apple-icloud</v-icon>Sales Force Owner:
            </span>
          </v-flex>
          <v-flex xs6 v-if="!editMode && getObjectById(tempCompany.user_id, 'users')">
            <v-label>
              <v-chip text-color="#444">
                <userAvatar
                  class="pl-2"
                  :size="14"
                  :last_name="
                    getObjectById(tempCompany.user_id, 'users').last_name
                  "
                  :first_name="
                    getObjectById(tempCompany.user_id, 'users').first_name
                  "
                  :url="getObjectById(tempCompany.user_id, 'users').avatar_url"
                />
                {{ getNameById(tempCompany.user_id, "users") }}
              </v-chip>
            </v-label>
          </v-flex>
          <v-flex xs5 v-if="editMode">
            <v-autocomplete
              :items="users"
              item-value="id"
              item-text="name"
              v-model="tempCompany.user_id"
              hide-details
              solo
              flat
              dense
              label="Sales Force Owner"
              single-line
              class="dense-input"
              background-color="#f4f4f4"
              browser-autocomplete="noautocomplete"
            />
          </v-flex>
        </v-layout>
      </v-card>
    </v-card>

    <collection
      v-if="tempCompany.id"
      formComponent="affiliateCompanyForm"
      resourceName="affiliate_companies"
      store="companyStore"
      :collectionHeaders="{
        name: 'String',
        address1: 'String',
        address2: 'String',
        country: 'commonResource',
        city: 'commonResource',
      }"
    />
    <v-layout row wrap pt-2>
      <v-spacer />
      <destroyModale
        resourceName="company"
        v-if="newCompany.id"
        :itemId="newCompany.id"
        warningText="You are going to remove this Company and its associated contacts and products permanently"
        redirectRoute="companies"
        :fab="false"
        :show_label="true"
        :flat="false"
        :small="true"
        :small_icon="true"
        label="Remove this company from the application"
        color="error"
      />
    </v-layout>

    <!-- <json-viewer :value="tempCompany"></json-viewer> -->
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import collection from "../shared/collection";
import uploader from "../shared/uploader";
import userAvatar from "../shared/userAvatar";
import JsonViewer from "vue-json-viewer";
import UPDATE_COMPANY from "../../graphql/companies/update.gql";
import CREATE_COMPANY from "../../graphql/companies/create.gql";

export default {
  data() {
    return {
      editMode: false,
      uploadLogoDialog: false,
      s3bucket: process.env.VUE_APP_S3_BUCKET_URL,
      tempCompany: {},
      companyTypeIndex: 0,
    };
  },
  components: {
    collection,
    uploader,
    userAvatar,
    JsonViewer,
  },
  computed: {
    ...mapGetters("commonStore", [
      "countries",
      "cities",
      "users",
      "citiesFromCountry",
      "companyStatuses",
      "languages",
      "getNameById",
      "getObjectById",
    ]),
    ...mapGetters("companyStore", ["newCompany"]),
    companyLogoName() {
      return this.tempCompany.name.replace(/[^a-z0-9_-]/gi, "").toLowerCase();
    },
  },
  methods: {
    getCompanyTypeIndex() {
      if (this.tempCompany.isSupplier) return 0;
      if (this.tempCompany.isCustomer) return 1;
      if (this.tempCompany.isSubsidiary) return 2;
    },
    resetTempCompany() {
      this.tempCompany = JSON.parse(JSON.stringify(this.newCompany));
      this.companyTypeIndex = this.getCompanyTypeIndex();
      if (!this.tempCompany.id) {
        this.editMode = true;
      }
    },
    updateCompanyType(index) {
      this.tempCompany.isSupplier = false;
      this.tempCompany.isCustomer = false;
      this.tempCompany.isSubsidiary = false;
      if (index == 0) {
        this.tempCompany.isSupplier = true;
      }
      if (index == 1) {
        this.tempCompany.isCustomer = true;
      }
      if (index == 2) {
        this.tempCompany.isSubsidiary = true;
      }
    },
    save() {
      if (this.tempCompany.subsidiary)
        delete this.tempCompany.subsidiary.bank_informations;

      if (this.tempCompany.customer)
        delete this.tempCompany.customer.documentary_instructions;

      if (this.tempCompany.id) {
        this.sendMutation(
          "update",
          "company",
          UPDATE_COMPANY,
          this.tempCompany
        ).then(() => {
          this.editMode = false;
          //  this.newCompany = JSON.parse(JSON.stringify(this.tempCompany));
        });
      } else {
        this.tempCompany.isSubsidiary = true;
        this.sendMutation(
          "create",
          "company",
          CREATE_COMPANY,
          this.tempCompany
        ).then((mutation_return) => {
          this.editMode = false;
          const id = mutation_return.create_company.id;
          this.$router.replace({
            name: "company",
            params: { id: id },
          }).then(() => {
            this.$emit("companyCreated")
          });
          //  this.newCompany = JSON.parse(JSON.stringify(this.tempCompany));
        });
      }
    },
    cancel() {
      // Reset form to old values
      this.resetTempCompany();
      this.editMode = false;
      if (!this.tempCompany.id) {
        this.$router.push({
        name: "companies"

      });
      }
    },
    updateCompanyLogo(real_file_name) {
      let extension = real_file_name.split(".")[
        real_file_name.split(".").length - 1
      ];
      let final_filename = this.companyLogoName + "." + extension;
      this.tempCompany.logo_url = final_filename;
      // this.updateModel(
      //   "companyStore",
      //   "newCompany",
      //   "logo_url",
      //   final_filename
      // );
    },
  },
  created() {
    this.resetTempCompany();
  },
  watch: {
    companyTypeIndex() {
      if (this.tempCompany) this.updateCompanyType(this.companyTypeIndex);
    },
  },
};
</script>
<style>

.v-chip .v-avatar {
  width: 14px !important;
  height: 14px !important;
  min-width: 14px !important;
}
</style>
<style lang="stylus" scoped>
.dense-input >>> .v-input__control {
  min-height: 28px !important;
  height: 28px !important;
  font-size: 14px;
}
</style>
